
import {
    SiReact,
    SiNextdotjs,
    SiTypescript,
    SiNodedotjs,
    SiTailwindcss,
    SiFramer,
    SiMongodb,
    SiPostgresql,
    SiVercel,
    SiFigma,
    SiStripe,
    SiSupabase
} from "react-icons/si";

import { MdEmail } from "react-icons/md";

export const CONTACT = {
    whatsapp: "918074977454",
    whatsappDisplay: "+91 80749 77454",
    email: "hello@rsdwebstudio.com",
    location: "India · Worldwide remote",
};

export const NAV_LINKS = [
    { id: "home", label: "Home" },
    { id: "services", label: "Services" },
    { id: "work", label: "Work" },
    { id: "process", label: "Process" },
    { id: "about", label: "About" },
    { id: "pricing", label: "Pricing" },
    { id: "faq", label: "FAQ" },
];

export const SERVICES = [
    {
        icon: "Palette",
        title: "Custom Website Design",
        desc: "Hand-crafted designs that reflect your brand. No cookie-cutter templates — every pixel is intentional.",
    },
    {
        icon: "Smartphone",
        title: "Responsive Development",
        desc: "Flawless on phones, tablets, and desktops. Your customers find you wherever they are.",
    },
    {
        icon: "Search",
        title: "SEO Foundations",
        desc: "Get found on Google. Local SEO, structured data, fast indexing — built in from day one.",
    },
    {
        icon: "Zap",
        title: "Speed Optimization",
        desc: "Sub-2-second load times. Your visitors don't wait. They convert.",
    },
    {
        icon: "Wrench",
        title: "Maintenance & Support",
        desc: "Updates, backups, security patches, and uptime monitoring. Sleep easy.",
    },
    {
        icon: "Sparkles",
        title: "Branding & Logo",
        desc: "A memorable identity for your business — logo, palette, and brand guidelines.",
    },
];
export const TECH_STACK = [
    { name: "React", icon: SiReact },
    { name: "Next.js", icon: SiNextdotjs },
    { name: "TypeScript", icon: SiTypescript },
    { name: "Node.js", icon: SiNodedotjs },
    { name: "Tailwind", icon: SiTailwindcss },
    { name: "Framer Motion", icon: SiFramer },
    { name: "MongoDB", icon: SiMongodb },
    { name: "Resend", icon: MdEmail },
    { name: "PostgreSQL", icon: SiPostgresql },
    { name: "Vercel", icon: SiVercel },
    { name: "Figma", icon: SiFigma },
    { name: "Stripe", icon: SiStripe },
    { name: "Supabase", icon: SiSupabase },
];
export const PORTFOLIO = [
    {
        id: "GlamsbyRuby",
        name: "GlamsbyRuby",
        type: "Personal Stylist",
        summary: "A sleek, stylish site with booking and Instagram feed integration.",
        image: "/images/glamsbyruby.jpg",
        tags: ["Booking", "Instagram", "Storytelling"],
        location: "London, UK 🇬🇧",
        span: "lg:col-span-1 lg:row-span-1",
        urllink: "https://glamsbyruby.vercel.app/"
    },
    {
        id: "Hospital",
        name: "Sudheeksha Hospital",
        type: "Healthcare Clinic",
        summary: "Online appointment booking, doctor bios, and patient testimonials.",
        image: "/images/sudheeksha.jpg",
        tags: ["Booking", "CMS"],
        location: "India 🇮🇳",
        span: "lg:col-span-1 lg:row-span-1",
        urllink: "https://sudheekshahospital-demo.vercel.app/"
    },
    {
        id: "AgentDNA",
        name: "AgentDNA",
        type: "Agentic platform",
        summary: "Upgrade autonomous agents into secure, explainable systems with real-time digital trail",
        image: "/images/agentdna.jpg",
        tags: ["AI-Agent", "CMS", "Local SEO"],
        location: "Singapore 🇸🇬",
        span: "lg:col-span-1 lg:row-span-1",
        urllink: "https://agentdna.io/"
    },
    {
        id: "Trie",
        name: "TRIE",
        type: "Verifiable data providers",
        summary: "Empowering creators, data providers, and enterprises to build verifiable AI",
        image: "/images/trie.jpg",
        tags: ["Wallet", "Whitepaper", "Booking", "Subscription"],
        location: "USA 🇺🇸",
        span: "lg:col-span-1 lg:row-span-1",
        urllink: "https://trie.network/"
    },
    {
        id: "Rubix",
        name: "Rubix Network",
        type: "AI Economy",
        summary: "A sleek, stylish site with booking integration.",
        image: "/images/rubix.jpg",
        tags: ["AI Economy", "Graph Database", "Token Gating"],
        location: "Singapore 🇸🇬",
        span: "lg:col-span-1 lg:row-span-1",
        urllink: "https://rubix.net/"
    },
    {
        id: "JupiterMeta",
        name: "Jupiter Meta",
        type: "Secure Data",
        summary: "Trust-first design with transparent pricing and online appointment booking.",
        image: "/images/jupitermeta.png",
        tags: ["Data", "Booking", "Decentralization"],
        location: "India 🇮🇳",
        span: "lg:col-span-1 lg:row-span-1",
        urllink: "https://jupitermeta.io/"
    }
];

export const PROCESS = [
    { step: "01", title: "Discover", desc: "We talk. I learn your business, customers, and goals — no jargon, no pressure." },
    { step: "02", title: "Design", desc: "I sketch, prototype, and refine. You see real screens before a single line of code." },
    { step: "03", title: "Build", desc: "Clean, fast, semantic code. Mobile-first. Tested across every device." },
    { step: "04", title: "Launch", desc: "Domain, hosting, SEO, and analytics — wired up. Then I hand you the keys." },
];

export const STATS = [
    { value: "100+", label: "Sites shipped" },
    { value: "<2s", label: "Avg load time" },
    { value: "99%", label: "Client retention" },
    { value: "24h", label: "Response time" },
];

// export const TECH_STACK = [
//     "React", "Next.js", "TypeScript", "Node.js",
//     "Tailwind", "Framer Motion", "MongoDB", "PostgreSQL",
//     "Vercel", "AWS", "Figma", "Stripe",
// ];

export const TESTIMONIALS = [
    {
        name: "Manasa Rajan",
        role: "Owner, JupiterMeta",
        quote: "Sachin understood our brand in one call. Our online orders tripled in two months.",
    },
    {
        name: "K Chakradhar Reddy",
        role: "Founder, Rubix",
        quote: "The site loads instantly and looks better than my competitors who paid 5x more.",
    },
    {
        name: "Chandrasheker",
        role: "Director, AgentDNA",
        quote: "Sachin built our agentdna website in 5 days and we started getting booking calls within the first week.",
    },
];



export const COUNTRIES = [
    { code: 'US', label: 'United States', flag: '🇺🇸' },
    { code: 'UK', label: 'United Kingdom', flag: '🇬🇧' },
    { code: 'UAE', label: 'United Arab Emirates', flag: '🇦🇪' },
    { code: 'CA', label: 'Canada', flag: '🇨🇦' },
    { code: 'DE', label: 'Germany', flag: '🇩🇪' },
    { code: 'FR', label: 'France', flag: '🇫🇷' },
    { code: 'IN', label: 'India', flag: '🇮🇳' },
    { code: 'AU', label: 'Australia', flag: '🇦🇺' },
    { code: 'SG', label: 'Singapore', flag: '🇸🇬' },
    { code: 'NL', label: 'Netherlands', flag: '🇳🇱' },
];


export const PRICING = [
    {
        tier: "Starter",
        price: "£749",
        sub: "One-time",
        desc: "Perfect for new businesses needing a credible online presence.",
        features: [
            "Mobile responsive",
            "Contact form + WhatsApp",
            "Hosting + Basic SEO setup",
            "1 round of revision",
            "30-minute discovery call",
            "Content guidance",
            "SSL certificate setup",
            "Domain setup guidance",
            "7 days delivery",
            "Monthly retainer - £50/mo (optional)"
        ],
        highlighted: false,
    },
    {
        tier: "Best Value",
        price: "£1499",
        sub: "One-time",
        desc: "For businesses that want to show up on Google and turn visitors into paying customers.",
        features: [

            "Everything in starter",
            "Search Console setup",
            "Business Profile setup",
            "CMS / blog setup",
            "Advanced local SEO",
            "Google Analytics",
            "3 rounds of revisions",
            "30 days post-launch support",
            "Bookings setup",
            "Social media integrations",
            "10 days delivery",
            "Monthly retainer - £100/mo (optional)"

        ],
        highlighted: true,
    },

    {
        tier: "Advance",
        price: "£2999",
        sub: "One-time",
        desc: "For businesses that want more inquiries, bookings, and real customers online.",
        features: [

            "Everything in Growth",
            "Custom animations",
            "CMS / blog setup",
            "Advanced local SEO",
            "Google Analytics",
            "Search Console",
            "Business Profile",
            "Bookings setup",
            "Admin dashboard",
            "Performance optimization",
            "Social media integrations",
            "5 rounds of revisions",
            "60 days post-launch support",
            "15 days delivery",
            "Monthly retainer - £150/mo (optional)"
        ],
        highlighted: false,
    },
    {
        tier: "Premium",
        price: "£6999+",
        sub: "Custom",
        desc: "Bespoke web platforms with bookings, payments, and integrations.",
        features: [

            "Bookings",
            "Search Console",
            "Business Profile",
            "Payment gateway",
            "API integrations",
            "Custom dashboard",
            "Performance audit",
            "Branding & logo",
            "Social media integrations",
            "Unlimited revisions",
            "90 days premium support",
            "Custom delivery timeline",
            "Monthly retainer - Custom pricing (optional)"
        ],
        highlighted: false,
    },
];

export const FAQS = [
    {
        q: "How long does a typical project take?",
        a: "Most small-business sites ship in 1-2 weeks from kickoff to launch. Larger projects with bookings or e-commerce take 2-4 weeks.",
    },
    {
        q: "Do I own the website after launch?",
        a: "100%. The code, the domain, the content — all yours. You also get full admin access and a handover walkthrough.",
    },
    {
        q: "What if I need changes after launch?",
        a: "Every package includes post-launch support. After that, you can hire me hourly or on a small monthly retainer.",
    },
    {
        q: "Can you help me write content?",
        a: "Yes. I help structure copy, suggest headlines, and arrange your photos. For long-form copy, I partner with trusted writers.",
    },
    {
        q: "Do you work with businesses outside India?",
        a: "Absolutely. I work remotely worldwide. Calls happen on Zoom or WhatsApp at a time that suits you.",
    },
    {
        q: "Do I need to pay yearly for anything?",
        a: "Yes, domain and hosting need yearly renewal. Domain usually costs around $10–$30/year. Hosting depends on your plan. I can help you manage everything if needed.",
    },
    {
        q: "What tech do you build with?",
        a: "Modern stack: React / Next.js, Tailwind, Node.js, MongoDB / Postgres, deployed on Vercel or AWS. Every site is fast and scalable.",
    }

]